var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.25 12c0 5.66-4.59 10.25-10.25 10.25S1.75 17.66 1.75 12 6.34 1.75 12 1.75 22.25 6.34 22.25 12m1 0c0 6.213-5.037 11.25-11.25 11.25S.75 18.213.75 12 5.787.75 12 .75 23.25 5.787 23.25 12M12 4.938a.5.5 0 0 1 .5.5V11.5h6.063a.5.5 0 0 1 0 1H12.5v6.063a.5.5 0 0 1-1 0V12.5H5.438a.5.5 0 0 1 0-1H11.5V5.438a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
});
const SvgAddCircle = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCircle);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMi4yNSAxMkMyMi4yNSAxNy42NjA5IDE3LjY2MDkgMjIuMjUgMTIgMjIuMjVDNi4zMzkwOCAyMi4yNSAxLjc1IDE3LjY2MDkgMS43NSAxMkMxLjc1IDYuMzM5MDggNi4zMzkwOCAxLjc1IDEyIDEuNzVDMTcuNjYwOSAxLjc1IDIyLjI1IDYuMzM5MDggMjIuMjUgMTJaTTIzLjI1IDEyQzIzLjI1IDE4LjIxMzIgMTguMjEzMiAyMy4yNSAxMiAyMy4yNUM1Ljc4NjggMjMuMjUgMC43NSAxOC4yMTMyIDAuNzUgMTJDMC43NSA1Ljc4NjggNS43ODY4IDAuNzUgMTIgMC43NUMxOC4yMTMyIDAuNzUgMjMuMjUgNS43ODY4IDIzLjI1IDEyWk0xMiA0LjkzNzU5QzEyLjI3NjEgNC45Mzc1OSAxMi41IDUuMTYxNDUgMTIuNSA1LjQzNzU5VjExLjVIMTguNTYyNUMxOC44Mzg2IDExLjUgMTkuMDYyNSAxMS43MjM5IDE5LjA2MjUgMTJDMTkuMDYyNSAxMi4yNzYxIDE4LjgzODYgMTIuNSAxOC41NjI1IDEyLjVIMTIuNVYxOC41NjI2QzEyLjUgMTguODM4NyAxMi4yNzYxIDE5LjA2MjYgMTIgMTkuMDYyNkMxMS43MjM5IDE5LjA2MjYgMTEuNSAxOC44Mzg3IDExLjUgMTguNTYyNlYxMi41SDUuNDM3NUM1LjE2MTM2IDEyLjUgNC45Mzc1IDEyLjI3NjEgNC45Mzc1IDEyQzQuOTM3NSAxMS43MjM5IDUuMTYxMzYgMTEuNSA1LjQzNzUgMTEuNUgxMS41VjUuNDM3NTlDMTEuNSA1LjE2MTQ1IDExLjcyMzkgNC45Mzc1OSAxMiA0LjkzNzU5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";